const testimonials = [
  {
    name: "Rajesh Sharma",
    designation: "Pharma Franchise Partner",
    message: "Chemo Biological has been a reliable partner for our pharma business. Their product quality, professional support, and timely service have made our experience excellent.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Amit Verma",
    designation: "PCD Pharma Distributor",
    message: "We are very happy with the quality and variety of products offered by Chemo Biological. Their team is supportive and always responds quickly to our requirements.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/44.jpg",
  },
  {
    name: "Sandeep Kumar",
    designation: "Pharma Franchise Associate",
    message: "Working with Chemo Biological has been a smooth and rewarding experience. Their wide product range and excellent business support make them a trusted pharma partner.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/51.jpg",
  },
  {
    name: "Manish Gupta",
    designation: "Pharmaceutical Distributor",
    message: "The quality of medicines and overall service provided by Chemo Biological is impressive. Their team is cooperative, professional, and committed to supporting franchise partners.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/61.jpg",
  },
  {
    name: "Rohit Singh",
    designation: "PCD Business Partner",
    message: "Chemo Biological offers a great combination of quality products, reliable delivery, and marketing support. We are pleased with our association and look forward to growing together.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/72.jpg",
  },
  {
    name: "Deepak Yadav",
    designation: "Pharma Marketing Executive",
    message: "Our experience with Chemo Biological has been excellent. The company maintains consistent product quality and provides valuable assistance whenever we need it.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/82.jpg",
  },
  {
    name: "Vijay Meena",
    designation: "Pharma Franchise Owner",
    message: "I appreciate the professional approach of the Chemo Biological team. From product selection to order processing, everything is handled efficiently and transparently.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/86.jpg",
  },
  {
    name: "Anil Kumar",
    designation: "Pharmaceutical Business Partner",
    message: "Chemo Biological has helped us build confidence in our pharma business with its quality products and dependable support. We are happy to be associated with them.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/91.jpg",
  },
  {
    name: "Pankaj Verma",
    designation: "PCD Franchise Partner",
    message: "The product portfolio is impressive, and the team is extremely helpful. Chemo Biological understands the needs of its business partners and provides excellent support.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/22.jpg",
  },
  {
    name: "Nitin Sharma",
    designation: "Pharma Distributor",
    message: "Highly satisfied with Chemo Biological. Their quality-focused approach, diverse pharmaceutical range, and professional service make them a dependable choice for pharma franchise business.",
    rating: 5,
    img: "https://randomuser.me/api/portraits/men/11.jpg",
  }
];

export default testimonials;
